import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import OverzichtForm from "./OverzichtForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import OverzichtPageHelper from "./OverzichtPageHelper";
import PropTypes from 'prop-types';
import * as layoutActions from "../../../actions/zoekmotorLayoutActions";
import redirector from "../../../util/redirector";
import { throwException } from "../../../actions/exceptionActions";

class OverzichtPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: null,
            errors: null,
            tochtTypes: [],
            lusTypes: []
        };

        this.pageHelper = new OverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    isReadyToRender = () => {
        return this.state.model || this.state.errors;
    };

    handleOnMeerTochten = () => this.pageHelper.onMeerTochten();

    handleOnChange = (event) => this.pageHelper.onChange(event);

    handleOnSearch = (event) => this.pageHelper.onSearch(event);

    render() {
        if (!this.isReadyToRender())
            return null;

        const model = this.state.model;
        const provincies = this.props.provincies;
        const errors = this.state.errors;

        return (
            <OverzichtForm
                model={model}
                errors={errors}
                provincies={provincies}
                tochtTypes={this.state.tochtTypes}
                lusTypes={this.state.lusTypes}
                onMeerTochten={this.handleOnMeerTochten}
                onChange={this.handleOnChange}
                onSearch={this.handleOnSearch}
            />);
    }
}

OverzichtPage.propTypes = {
    provincies: PropTypes.array.isRequired
};

OverzichtPage.defaultProps = {
    provincies: []
};

function mapStateToProps(state, ownProps) {
    return {
        provincies: state.referentie.provinciesInVlaamsGewest
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        loadOverzichtLayout: bindActionCreators(layoutActions.loadOverzichtPageLayout, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OverzichtPage);
